import React, { useState } from "react";
import MyNavbar from "../navbar";
import Customermenu from "./Customermenu";
import Footer from "../footer";
import Customerbanner from "./Customerbanner";
import axios from "axios";
import Scrolltotopbtn from "../Scrolltotopbutton";
import Notification from "../Notification";

export default function Changepassword() {

  const [notification, setNotification] = useState(null);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewCnfmPassword, setShowNewCnfmPassword] = useState(false);


  const [values,setValues]= useState({
     oldpassword:'',
     newpassword:'',
     confirmpassword:''
  })

  const handlechange = (event) => {
    setValues((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  }
    
      const handleChangePassword = (e) => {
        e.preventDefault();
        const user = localStorage.getItem("token");
        const url = user === "admin" ? "updateadmin" : "updateuser";

        if (user !== "user" && user !== "admin") {
          return;
        }

        if (values.newpassword !== values.confirmpassword) {
          setNotification({ message: "Password and Confirm Passwords do not match.", type: 'error' });
          setTimeout(() => setNotification(null), 3000);
          return;
        }

        // The old password is checked by the server against the stored hash --
        // the browser is never given the hash to compare against.
        const updatedData = {
          oldpassword: values.oldpassword,
          password: values.newpassword,
        };

        axios
          .post(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/${url}/`, updatedData)
          .then((res) => {
            setNotification({ message: "Password updated successfully", type: 'success' });
            setTimeout(() => {
              setNotification(null);
              window.location.reload(false);
            },2000);
           
          })
          .catch((error) => {
            const message =
              error.response?.data?.message || "Error updating password";
            setNotification({ message, type: 'error' });
            setTimeout(() => setNotification(null), 3000);
          });
      };
      
      
      const handleToggleOldPassword = () => {
        setShowOldPassword(!showOldPassword);
      };
      const handleToggleNewPassword = () => {
        setShowNewPassword(!showNewPassword);
      };
      const handleToggleNewCnfmPassword = () => {
        setShowNewCnfmPassword(!showNewCnfmPassword);
      };


  return (
    <div className="fullscreen">
      <MyNavbar />
      {notification && <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />}

      <main>
      <Customerbanner />
      <div className="d-lg-flex justify-content-around p-2 ps-lg-5 pe-lg-5">
        <div className="col-lg-3 col-xs-12 col-md-12 p-lg-4 p-2">
          <Customermenu />
        </div>
        <div className="col-xs-12 col-md-12 col-lg-9 p-lg-4 p-2">
          <form onSubmit={handleChangePassword}>
            <div>
              <div className="d-md-flex col-md-8 col-xs-12 mt-3 mb-3">
                <label htmlFor="oldpassword" className="col-md-4 col-xs-12">
                  Old Password
                </label>
                <div className="d-flex col-md-8  passwordgroup">
                  <input
                    type={showOldPassword ? "text" : "password"}
                    name="oldpassword"
                    id="oldpassword"
                    placeholder="Old Password"
                    value={values.oldpassword}
                    className="form-control"
                    onChange={handlechange}
                    required
                  />
                  <button
                  type="button"
                  id="btnToggle"
                  className="toggle12 pe-3"
                  onClick={handleToggleOldPassword}
                >
                  <i
                    className={`bi ${
                      showOldPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
                  &nbsp;<span className="text-danger fs-4">*</span>
                </div>
              </div>

              <div className="d-md-flex col-md-8 col-xs-12 mt-3 mb-3">
                <label htmlFor="newpassword" className="col-md-4 col-xs-12">
                  New Password
                </label>
                <div className="d-flex col-md-8 passwordgroup">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="newpassword"
                    id="newpassword"
                    placeholder="New Password"
                    value={values.newpassword}
                    className="form-control"
                    onChange={handlechange}
                    required
                  />
                  <button
                  type="button"
                  id="btnToggle"
                  className="toggle12 pe-3"
                  onClick={handleToggleNewPassword}
                >
                  <i
                    className={`bi ${
                      showNewPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
                  &nbsp;<span className="text-danger fs-4">*</span>
                </div>
              </div>
              <div className="d-md-flex col-md-8 col-xs-12 mt-3 mb-3">
                <label htmlFor="confirmpassword" className="col-md-4 col-xs-12">
                  Confirm Password
                </label>
                <div className="d-flex col-md-8 passwordgroup">
                  <input
                    type={showNewCnfmPassword ? "text" : "password"}
                    name="confirmpassword"
                    id="confirmpassword"
                    placeholder="Confirm Password"
                    value={values.confirmpassword}
                    className="form-control"
                    onChange={handlechange}
                    required
                  />
                  <button
                  type="button"
                  id="btnToggle"
                  className="toggle12 pe-3"
                  onClick={handleToggleNewCnfmPassword}
                >
                  <i
                    className={`bi ${
                      showNewCnfmPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
                  &nbsp;<span className="text-danger fs-4">*</span>
                </div>
              </div>
            </div>
            <button type="submit" className="btn btn-success mt-3 mb-5" >
              Change Password
            </button>
          </form>
        </div>
      </div>
      </main>
      <Footer />
      <Scrolltotopbtn/>
    </div>
  );
}
